(function($) {

    $.fn.imageLoader = function(options) {
        // build main options before element iteration
        var opts = $.extend(true, {}, $.fn.imageLoader.defaults, options);

        return this.each(function() {
            var $this = $(this);
            // build element specific options
            var eOpts = $.metadata ? $.extend(true, {}, opts, $this.metadata()) : opts;
            eOpts = $.fn.dataset ? $.extend(true, eOpts, $this.dataset()) : eOpts;

            /* only init the plugin if the image hasn't already loaded */
            /* complete is always true in Firefox so also check that the image has height */
            if (!$this[0].complete || (!$this.height() == 0)) {
                $this.data('src', $this.attr('src'));

                $this.load(handler).error(handler).bind('abort', handler);
            }

            var $spinner, spinner;

            function handler(e) {
                var loaded = e.type == 'load';

                if(loaded) {
                    if ($spinner) {
                        // stop spinner (if spinning) once loaded
                        spinner.remove();
                        $spinner.parents('.thumbnail').find('.play-icon').show();
                        $spinner.remove();
                        $this.show();
                    }
                }
                else {
                    var retries = $this.data('retries') || 0;
                    // set src to force reload and slightly change url to prevent loading from cache
                    var src = $this.data('src') + '?d=' + new Date().getTime() + '&retry=true';
                    if(retries === 0) {
                        // The first time the image fails to load perform an AJAX request to work out the http code
                        // (the load callback does not provide the http code) do not retry for irrecoverable errors
                        $.ajax(src, {
                            supressErrorDialog: true,
                            success: function(data, textStatus, xhr) {
                                if (xhr.status === 200) {
                                    // Image is now available, so set src and do nothing
                                    $this.attr('src', src);
                                } else {
                                    handleError(xhr, src, retries);
                                }
                            },
                            error: function(xhr, textStatus, errorThrown) {
                                handleError(xhr, src, retries);
                            }
                        });
                    }
                    else {
                        doRetry(src, retries);
                    }
                }
            }

            function handleError(xhr, src, retries) {
                // if access denied (403), don't try again
                if (xhr.status !== 403) {
                    // unknown failure reason so start spinner and retry
                    $this.hide();
                    $spinner = $('<div/>').addClass('image-loading-spinner').insertAfter($this);
                    $spinner.parents('.thumbnail').find('.play-icon').hide();

                    spinner = Spinners.create($($spinner), eOpts.spinner).play();
                    doRetry(src, retries);
                }
            }

            function doRetry(src, retries) {
                if(retries < eOpts.retryLimit) {
                    // ... try again
                    setTimeout(function(){
                        $this.data('retries', ++retries);
                        if(retries === eOpts.retryLimit) {
                            src += '&canRetry=false';
                        }
                        $this.attr('src', src);
                    }, eOpts.retryInterval);
                }
                else {
                    if ($spinner) {
                        // give up
                        spinner.remove();
                        $spinner.remove();
                    }
                }
            }
        });
    };
    //
    // plugin defaults
    //
    $.fn.imageLoader.defaults = {
        retryLimit: 10, // number of times to attempt to load the image before giving up
        retryInterval: 1000, // number of milliseconds to wait between retries
        spinner: {
            radius: 4,
            height: 5,
            width: 1,
            dashes: 12,
            opacity: 1,
            padding: 3,
            rotation: 1000,
            color: '#000'
        }
    };

})(jQuery);
